import { useEffect } from "react";

// Sets the browser tab title to "Noxus Soft - <page>". The brand half is constant on purpose:
// deriving it from the loaded partner made the tab flash the fallback first, then swap once the
// brand query resolved. document.title is set imperatively rather than relying on React's
// <title> hoisting (which can leave index.html's title stuck).
export function PageTitle({ children }) {
  const title = children ? `Noxus Soft - ${children}` : "Noxus Soft";

  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
}
